/**
 * Consumer e-commerce legal pages (distance sales, delivery, cancellation / return) apply to the
 * public self-service product only; customer (single-tenant) deployments set
 * REACT_APP_CONSUMER_LEGAL_PAGES=false to hide them.
 */
export const CONSUMER_LEGAL_PATHS = ["/distance-sales", "/delivery-conditions", "/cancellation-return"];

export function consumerLegalPagesEnabled(env = process.env) {
  return env.REACT_APP_CONSUMER_LEGAL_PAGES !== "false";
}

export function filterConsumerLegalRoutes(routeList, enabled = consumerLegalPagesEnabled()) {
  if (enabled) return routeList;
  return routeList.filter((r) => !CONSUMER_LEGAL_PATHS.includes(r.path));
}

/**
 * Admin e-mail for new support tickets (`mail` outbox read by the Trigger Email extension).
 * Off unless REACT_APP_SUPPORT_EMAIL=true; while off nothing is queued and only the in-app
 * notification is sent.
 */
export function supportEmailEnabled(env = process.env) {
  return env.REACT_APP_SUPPORT_EMAIL === "true";
}
